const dishes = [
    '原味汤粉',
    '粥瓜婆',
    '重庆小面',
    '螺蛳粉',
    '炒粉',
    '番茄炒蛋',
    '粿条',
    '饺子',
    '西安面食',
    '葱油饼 & 酱香饼'
];
const foodData = dishes.map(d => ({ name: d }));
export default foodData;
